module.exports = __webpack_public_path__ + "static/B28_Dixon-295de36e285e544ad6b9554d6658bcfd.jpg";